import axios from 'axios'
import router from '@/router'
import { setToken, getToken } from '@/utils/auth'
import { tansParams } from "@/utils/common"
import cache from '@/plugins/cache'

let downloadLoadingInstance
// 再ログインを表示するかどうか
export let isRelogin = { show: false }
import loading from '@/assets/js/loading'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// axios.defaults.headers['Content-Type'] = 'multipart/form-data'
// axios インスタンスを作成する
const service = axios.create({
  // axios のリクエスト構成には baseURL オプションがあり、リクエスト URL の公開部分を示します。
  baseURL: process.env.VUE_APP_BASE_API,
  // タイムアウト
  timeout: 10000 * 600
})

// requestインターセプター
service.interceptors.request.use(config => {
  if (loading.loading.loadFlag) {
    loading.loading.show();
  }
  // データの重複送信を防ぐ必要がありますか
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  // getリクエストマッピング　paramsパラメータ
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }

  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    if (getToken()) {
      config.headers['csrf_token'] = getToken()
    }
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                  // リクエストアドレス
      const s_data = sessionObj.data;                // リクエストデータ
      const s_time = sessionObj.time;                // リクエスト時間
      const interval = 1000;                         // 間隔時間 (ms)、この時間に満たない場合は、重複提出と見なされます
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = 'データは処理中です。重複して提出しないでください。';
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
  Promise.reject(error)
})

// エラー情報処理
const err = (error) => {
  if (error.response) {
    const data = error.response.data
    switch (error.response.status) {
      case 403:
        router.push({ name: 'Error' })
        break
      case 404:
        router.push({ name: 'Error' })
        break
      case 409:
        router.push({ name: 'Error' })
        break
      default:
        loading.loading.hide();
        return Promise.reject()
    }
    loading.loading.hide();
  }
  loading.loading.hide();
  return Promise.reject(error)
}

// 応答インターセプター
service.interceptors.response.use(res => {
  loading.loading.hide();
  if (res.headers["csrf_token"]) {
    setToken(res.headers["csrf_token"])
  }
  if (res.data.code === 500) {
    router.push({ name: 'Error' })
    return
  }
  return res.data
}, err)

export default service